import store from "@/state/store";

export default [
    {
        path: "/login",
        name: "login",
        component: () => import("../views/account/login.vue"),
        meta: {
            title: "Login",
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "default"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/forgot-password",
        name: "Forgot password",
        component: () => import("../views/account/forgot-password.vue"),
        meta: {
            title: "Forgot Password",
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "default"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/",
        name: "default",
        meta: {
            title: "Dashboard",
            authRequired: true,
        },
        component: () => import("../views/index.vue"),
    },
    {
        path: "/discounts",
        name: "discounts",
        meta: {
            title: "Наценки",
            authRequired: true,
        },
        component: () => import("../views/forms/discounts.vue"),
    },
    {
        path: "/faq",
        name: "faq",
        meta: {
            title: "Оплата и доставка",
            authRequired: true,
            content: true
        },
        component: () => import("../views/forms/faq.vue"),
    },
    {
        path: "/contacts",
        name: "contacts",
        meta: {
            title: "Контактные данные",
            authRequired: true,
        },
        component: () => import("../views/forms/contacts.vue"),
    },
    {
        path: "/main",
        name: "main",
        meta: {
            title: "Настройки главной",
            authRequired: true,
        },
        component: () => import("../views/forms/main.vue"),
    },
    {
        path: "/mail",
        name: "mail",
        meta: {
            title: "Почтовый шаблон",
            authRequired: true,
        },
        component: () => import("../views/forms/mail.vue"),
    },
    {
        path: "/bodymail/authorisation",
        name: "bodymail_authorisation",
        meta: {
            title: "Шаблона авторизации",
            authRequired: true,
        },
        component: () => import("../views/forms/bodymails.vue"),
    },
    {
        path: "/bodymail/registration",
        name: "bodymail_registration",
        meta: {
            title: "Шаблона регистрации",
            authRequired: true,
        },
        component: () => import("../views/forms/registration.vue"),
    },
    {
        path: "/bodymail/sendorderrefund",
        name: "bodymail_sendorderrefund",
        meta: {
            title: "Шаблона отмены заказа",
            authRequired: true,
        },
        component: () => import("../views/forms/sendorderrefund.vue"),
    },
    {
        path: "/bodymail/sendorderstatus",
        name: "bodymail_sendorderstatus",
        meta: {
            title: "Шаблона статуса заказа",
            authRequired: true,
        },
        component: () => import("../views/forms/sendorderstatus.vue"),
    },
    {
        path: "/bodymail/sendorderstatus2",
        name: "bodymail_sendorderstatus2",
        meta: {
            title: "Шаблона 'Ваш заказ принят'",
            authRequired: true,
        },
        component: () => import("../views/forms/sendorderstatus2.vue"),
    },
    {
        path: "/bodymail/sendorderstatus3",
        name: "bodymail_sendorderstatus3",
        meta: {
            title: "Шаблона 'Товары поступили на склад в Германии'",
            authRequired: true,
        },
        component: () => import("../views/forms/sendorderstatus3.vue"),
    },
    {
        path: "/delivery",
        name: "delivery",
        meta: {
            title: "Доставка",
            authRequired: true,
        },
        component: () => import("../views/forms/delivery.vue"),
    },
    {
        path: "/gpt",
        name: "gpt",
        meta: {
            title: "Чат GPT",
            authRequired: true,
        },
        component: () => import("../views/forms/gpt.vue"),
    },
    {
        path: "/avaliabler",
        name: "avaliabler",
        meta: {
            title: "Настройки прокси",
            authRequired: true,
        },
        component: () => import("../views/forms/avaliabler.vue"),
    },
    {
        path: "/users",
        name: "users",
        meta: {
            title: "Users",
            authRequired: true,
        },
        component: () => import("../views/users/users.vue"),
    },
    {
        path: "/ms-report",
        name: "ms-report",
        meta: {
            title: "Report",
            authRequired: true,
        },
        component: () => import("../views/buchgalter/items.vue"),
    },
    {
        path: "/operator",
        name: "operator",
        meta: {title: "Operator", authRequired: true},
        component: () => import("../views/operator/NewItems.vue"),
    },
    {
        path: "/orders",
        name: "orders",
        meta: {title: "Orders", authRequired: true},
        component: () => import("../views/orders/orders"),
    },
    {
        path: "/orders/:id",
        name: "order-detail",
        meta: {title: "Order Details", authRequired: true},
        component: () => import("../views/orders/order-detail"),
    },
    {
        path: "/news",
        name: "news",
        meta: {
            title: "Новости",
            content: true
        },
        component: () => import("../views/news/news.vue"),
    },
    {
        path: "/news/:id",
        name: "news-detail",
        meta: {
            title: "Новость детально",
            content: true
        },
        component: () => import("../views/news/news-detail.vue"),
    },
    {
        path: "/pages",
        name: "pages",
        meta: {
            title: "Текстовые страницы",
            content: true
        },
        component: () => import("../views/pages/news.vue"),
    },
    {
        path: "/pages/:id",
        name: "pages-detail",
        meta: {
            title: "Текстовая страница детально",
            content: true
        },
        component: () => import("../views/pages/news-detail.vue"),
    },
    {
        path: "/baners",
        name: "baners",
        meta: {
            title: "Банеры",
            content: true
        },
        component: () => import("../views/baners/baners.vue"),
    },
    {
        path: "/baners/:id",
        name: "baner-detail",
        meta: {
            title: "Банер детально",
            content: true
        },
        component: () => import("../views/baners/baner-detail.vue"),
    },
    {
        path: "/previos",
        name: "previos",
        meta: {
            title: "Преимущества",
            content: true
        },
        component: () => import("../views/previos/baners.vue"),
    },
    {
        path: "/previos/:id",
        name: "previos-detail",
        meta: {
            title: "Преимущества детально",
            content: true
        },
        component: () => import("../views/previos/baner-detail.vue"),
    },
    {
        path: "/baners-bottom",
        name: "baners-bottom",
        meta: {
            title: "Нижние банеры",
            content: true
        },
        component: () => import("../views/baners-bottom/baners.vue"),
    },
    {
        path: "/baners-bottom/:id",
        name: "baner-bottom-detail",
        meta: {
            title: "Нижний банер",
            content: true
        },
        component: () => import("../views/baners-bottom/baner-detail.vue"),
    },
    {
        path: "/print-label/:id",
        name: "print-label",
        meta: {title: "Print Label", authRequired: true},
        component: () => import("../views/operator/print"),
    },
];
